import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { DecodeStream } from './DecodeStream.js';
import { EncodeStream } from './EncodeStream.js';
export var Base = /*#__PURE__*/function () {
  function Base() {
    _classCallCheck(this, Base);
  }
  _createClass(Base, [{
    key: "fromBuffer",
    value: function fromBuffer(buffer) {
      var stream = new DecodeStream(buffer);
      return this.decode(stream);
    }
  }, {
    key: "toBuffer",
    value: function toBuffer(value) {
      var size = this.size(value);
      var buffer = new Uint8Array(size);
      var stream = new EncodeStream(buffer);
      this.encode(stream, value);
      return buffer;
    }
  }]);
  return Base;
}();